import React from "react";
import { useForm, Controller } from "react-hook-form";
import Select from "../../UI/Select/Select"; // assuming this is the correct path
import Input from "../../UI/Input/Input";
import BaseButton from "../../UI/BaseButton/BaseButton";
import LanguageIcon from "@mui/icons-material/Language";
import { useSelector } from "react-redux";
import { getCustomerAccount, transferFromBlockedMC } from "../../../util/API/transfer";
import { getBlockedMC } from "../../../util/API/externalaccounts";
import { useEffect } from "react";
import { useState } from "react";
import { InternalTransfer } from "../../../util/API/transfer";
import CustomAlert from "../../UI/CustomAlert/CustomAlert";
import PinPad from "../../PinPad/PinPad";
import { Box, CircularProgress } from "@mui/material";
import { getErrorMessage } from "../../../util/utilfunctions/utilFunctions";


function InternalTransfers() {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const user = useSelector((state) => state.usersList.userID);
  let pin = sessionStorage.getItem("pin");
  let agent = JSON.parse(sessionStorage.getItem("user")).payload?.body;

  // console.log(data)

  const [customerAccounts, setCustomerAccounts] = useState([]);
  const [selectedToOption, setSelectedToOption] = useState("");
  const [selectedFromOption, setSelectedFromOption] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [severity, setSeverity] = useState("error");
  const [message, setMessage] = useState("");
  const [header, setHeader] = useState("");
  const [showPinPad, setShowPinPad] = useState(false);
  const [externalAccounts, setExternalAccounts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  let isAdmin = sessionStorage.getItem("isAdmin");

  // console.log(isAdmin)

  const parentuserid = sessionStorage.getItem("parentuserid");

  const getAccounts = async () => {
    const response = await getCustomerAccount(user['User'].id);
    if (user['User'].profilestatus !== "4") {
      setCustomerAccounts(response.ServiceData.record.filter((record) => record.Vtransfersourcepis.piid !== "313"));
    }

    const records = response.ServiceData.record

    // Filter out duplicates based on unique identifiers (e.g., account ID)
    const uniqueRecords = records.filter(
      (record, index, self) =>
        index === self.findIndex(
          (r) => r.Vtransfersourcepis.acctID === record.Vtransfersourcepis.acctID
        )
    );

    setCustomerAccounts(uniqueRecords);
  };

  const fetchExternalAccounts = async () => {
    try {
      const response = await getBlockedMC(user['User'].id);
      const externalData = response?.payload?.record || [];
  
      const externalList = Array.isArray(externalData) ? externalData : [externalData];

      const filtered = externalList.filter(
        (r) => r?.Vuserpi4?.piid === "313"
      );

      setExternalAccounts(filtered);
    } catch (err) {
      console.error("Failed to fetch external accounts:", err);
    }
  };

  useEffect(() => {
    getAccounts();
    fetchExternalAccounts();
  }, []);

  const handleConfirm = (event, pin) => {
    let PIN = pin.join('');
    // sessionStorage.setItem("pin", PIN);
    onSubmit(event, PIN);
    setShowPinPad(false);
  };

  const pinConfiguration = useSelector((state) => state.login.pinConfiguration);
  // console.log(pinConfiguration)

  const onSubmit = async(event, pin) => {
    event.preventDefault()

    if (!inputValue) {  
      setShowAlert(true);
      setSeverity("error");
      setMessage("Please enter a value to be transferred");
      setHeader("Error");
      return;
    }

    if (!selectedToOption) {
      setShowAlert(true);
      setSeverity("error");
      setMessage("Please select an account to transfer to");
      setHeader("Error");
      return;
    }

    if (!selectedFromOption) {
      setShowAlert(true);
      setSeverity("error");
      setMessage("Please select an account to transfer from");
      setHeader("Error");
      return;
    }

    const isExternal = externalAccounts.some(
      (record) => record?.Vuserpi4?.acctID === selectedToOption
    );
    
    const selectedToAccount = isExternal
      ? externalAccounts?.find(
          (record) => record?.Vuserpi4?.acctID === selectedToOption
        )?.Vuserpi4
      : customerAccounts?.find(
          (record) => record?.Vtransfersourcepis?.acctID === selectedToOption
        )?.Vtransfersourcepis;

    console.log(selectedToAccount)
  

    try{
      setIsLoading(true);
      if (selectedToAccount?.status !== "2") {
        const response = await InternalTransfer(
          user['User'].id,
          user['User'].langID,
          // customerAccounts.filter((record) => record.Vtransfersourcepis.friendlyname === selectedToOption)[0].Vtransfersourcepis.id,
          // customerAccounts.filter((record) => record.Vtransfersourcepis.friendlyname === selectedToOption)[0].Vtransfersourcepis.piid,
          selectedToAccount?.id,
          selectedToAccount?.piid,
          customerAccounts.filter((record) => record?.Vtransfersourcepis?.acctID === selectedFromOption)[0]?.Vtransfersourcepis.id,
          customerAccounts.filter((record) => record?.Vtransfersourcepis?.acctID === selectedFromOption)[0]?.Vtransfersourcepis.piid,
          user['User'].countryid,
          user['User'].firstName,
          user['User'].lastName,
          // customerAccounts.filter((record) => record?.Vtransfersourcepis?.friendlyname === selectedToOption)[0].Vtransfersourcepis.currcode,
          selectedToAccount?.currcode,
          parseFloat(inputValue),
          user['User'].telephoneno,
          agent['User'].id, // agent
          agent['User'].firstName, // agent
          agent['User'].lastName, // agent
          pin,
          parentuserid
        ).then((response) => {
          if(response.payload === undefined) {
            // console.log(response); 
            setShowAlert(true);
            setSeverity("success");
            setMessage("Transfer Completed");
            setHeader("Congratulations!");
            
            if (pinConfiguration === "once") {
              sessionStorage.setItem("pin", pin);
            }
            
            setInputValue("");
          }
          else {
            const message = getErrorMessage(response);
            setShowAlert(true);
            setSeverity("error");
            setMessage("Transfer not completed: " + message);
            setHeader("Error!");
          }
        });
      }

      else {
        const response = await transferFromBlockedMC(
          user['User'].id,
          user['User'].langID,
          selectedToAccount?.id,
          selectedToAccount?.piid,
          customerAccounts.filter((record) => record?.Vtransfersourcepis?.acctID === selectedFromOption)[0]?.Vtransfersourcepis.id,
          customerAccounts.filter((record) => record?.Vtransfersourcepis?.acctID === selectedFromOption)[0]?.Vtransfersourcepis.piid,
          user['User'].countryid,
          user['User'].firstName,
          user['User'].lastName,
          selectedToAccount?.currcode,
          parseFloat(inputValue),
          user['User'].telephoneno,
          agent['User'].id, // agent
          agent['User'].firstName, // agent
          agent['User'].lastName, // agent
          pin,
          parentuserid,
          selectedToAccount?.acctID,
          customerAccounts.filter((record) => record?.Vtransfersourcepis?.acctID === selectedFromOption)[0]?.Vtransfersourcepis.acctID,
        ).then((response) => {
          if(response.payload === undefined) {
            // console.log(response); 
            setShowAlert(true);
            setSeverity("success");
            setMessage("Transfer Completed");
            setHeader("Congratulations!");
            
            if (pinConfiguration === "once") {
              sessionStorage.setItem("pin", pin);
            }
            
            setInputValue("");
          }
          else {
            const message = getErrorMessage(response);
            setShowAlert(true);
            setSeverity("error");
            setMessage("Transfer not completed: " + message);
            setHeader("Error!");
          }
        });
      }
    }
    catch(error){
      console.log(error);
      setShowAlert(true);
      setSeverity("error");
      setMessage("Unexpected Error");
      setHeader("Error!");
    } finally {
      setIsLoading(false);
    }

    getAccounts()
    fetchExternalAccounts();
  };


  // const toOptions = customerAccounts.filter(isAdmin === "false" ? (record) => record.Vtransfersourcepis?.friendlyname !== selectedFromOption && record.Vtransfersourcepis.piid !== "313" : (record) => record.Vtransfersourcepis.friendlyname !== selectedFromOption).map((record) => ({
  //   key: record.Vtransfersourcepis?.acctID,
  //   value: record.Vtransfersourcepis?.friendlyname,
  //   label: record.Vtransfersourcepis?.friendlyname + " - " + record.Vtransfersourcepis?.currcode + " " + record.Vtransfersourcepis?.balance
  // }));

  const rawToOptions = [
    ...customerAccounts
      .filter(isAdmin === "false"
        ? (record) =>
            record.Vtransfersourcepis?.acctID !== selectedFromOption &&
            record.Vtransfersourcepis.piid !== "313"
        : (record) =>
            record.Vtransfersourcepis.acctID !== selectedFromOption
      )
      .map((record) => ({
        key: record.Vtransfersourcepis.acctID,
        value: record.Vtransfersourcepis.acctID,
        label:
          record.Vtransfersourcepis.friendlyname +
          (record.Vtransfersourcepis.piid !== "229" &&
           record.Vtransfersourcepis.piid !== "230"
            ? " - " + record.Vtransfersourcepis.cardno?.slice(-4)
            : "") +
          " - " +
          record.Vtransfersourcepis.currcode +
          " " +
          record.Vtransfersourcepis.balance,
      })),
  
      ...(isAdmin === "true"
      ? externalAccounts
          .filter(
            (record) =>
              record.Vuserpi4.acctID !== selectedFromOption &&
              record.Vuserpi4.status === "2"
          )
          .map((record) => ({
            key: record.Vuserpi4.acctID,
            value: record.Vuserpi4.acctID,
            label:
              "[BLOCKED] " +
              record.Vuserpi4.friendlyname +
              " - " +
              record.Vuserpi4.currcode +
              " " +
              record.Vuserpi4.balance,
          }))
      : []),
  ];
  
  const seenAcctIds = new Set();
  const toOptions = rawToOptions.filter((item) => {
    if (seenAcctIds.has(item.key)) return false;
    seenAcctIds.add(item.key);
    return true;
  });
  

  const fromOptions = customerAccounts.filter((record) => record.Vtransfersourcepis.acctID !== selectedToOption).map((record) => ({
    key: record.Vtransfersourcepis.acctID,
    value: record.Vtransfersourcepis.acctID,
    label: record.Vtransfersourcepis.friendlyname + (record.Vtransfersourcepis.piid !== "229" &&
    record.Vtransfersourcepis.piid !== "230"
     ? " - " + record.Vtransfersourcepis.cardno?.slice(-4)
     : "") + " - " + record.Vtransfersourcepis.currcode + " " + record.Vtransfersourcepis.balance
  }));

  const handleTransferButton = () => {
    if (!inputValue || parseFloat(inputValue) === 0) {  
      setShowAlert(true);
      setSeverity("error");
      setMessage("Please enter a value greater than 0 to be deposited");
      setHeader("Error");
      return;
    }

    if (!selectedToOption) {
      setShowAlert(true);
      setSeverity("error");
      setMessage("Please select an account to transfer to");
      setHeader("Error");
      return;
    }

    if (!selectedFromOption) {
      setShowAlert(true);
      setSeverity("error");
      setMessage("Please select an account to transfer from");
      setHeader("Error");
      return;
    }

    setShowPinPad(true);
  }

  return (
    <Box>
      <Box className="d-flex justify-content-center gap-3 align-items-center">
        <LanguageIcon />
        <Box className="header">Internal Transfers</Box>
      </Box>

      {isLoading == true ? (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                overflow: "hidden",
            }}
        >
            <CircularProgress />
        </Box>
      ) : (
        <form onSubmit={handleSubmit(onSubmit)}>
          <Controller
            name="fromAccount"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <Select
                {...field}
                label="From Account"
                options={toOptions}
                errorMessage={errors.toAccount && "This field is required"}
                onChange={(e) => setSelectedToOption(e.target.value)}
              />
            )}
          />

          <Controller
            name="toAccount"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <Select
                {...field}
                label="To Account"
                options={fromOptions}
                errorMessage={errors.fromAccount && "This field is required"}
                onChange={(e) => setSelectedFromOption(e.target.value)}
              />
            )}
          />

          <Controller
            name="amount"
            control={control}
            rules={{ required: "This field is required" }}
            render={({ field }) => (
              <Input
                {...field}
                label="Amount"
                type="number"
                errorMessage={errors.amount && errors.amount.message}
                // onChange={(e) => {
                //   setInputValue(e.target.value);
                //   field.onChange(e);
                // }}
                onChange={(e) => {
                  const newValue = e.target.value;
                  // Allow empty string for deletion or only non-negative numbers
                  if (newValue === "" || (!isNaN(newValue) && Number(newValue) >= 0)) {
                    setInputValue(newValue);
                    field.onChange(e);
                  } else {
                    setShowAlert(true);
                    setSeverity("error");
                    setMessage("Please enter a valid amount.");
                    setHeader("Error!");
                  }
                }}
                value={inputValue}
                textAlign={"right"}
                error={!inputValue}
              />
            )}
          />

          <Box className="pt-3 d-flex justify-content-end">
            <BaseButton 
              type="submit" 
              buttonText="Transfer"
              onClick={(e) => {pin ? onSubmit(e, pin) : pinConfiguration === "never" ? onSubmit(e, '0000') :  handleTransferButton()}}
            >
              Transfer
            </BaseButton>
          </Box>
        </form>
      )}

      <CustomAlert 
        severity={severity} 
        show={showAlert} 
        header={header} 
        message={message} 
        onClick={() => setShowAlert(false)} 
        autoclose={severity === "error" ? false : true} 
      />
      {showPinPad && 
        <PinPad 
          show={showPinPad} 
          handleConfirm={handleConfirm} 
          onClick={() => setShowPinPad(false)} 
        />
      }
    </Box>
  );
}

export default InternalTransfers;